// import { httpClient } from "@/app/shared/services";

import { apiConstants } from "../../config";
import { apiPost } from "../../../../shared/services";

const resetPassword = async (data, validator) => {
  let url = apiConstants.reset;
  return await apiPost(url, { ...data }, validator);
};

const sendResetMail = async (data, validator) => {
  let url = apiConstants.forgot;
  return await apiPost(url, { ...data }, validator);
};

export { resetPassword, sendResetMail };
